import { JsonDataBlobComponentFragment } from '@graphql/generated';
import { CustomComponentsProps } from '@website-editor/customComponents/CustomComponents';
import React from 'react';
import { useGetJSONComponents } from './useGetJSONComponents';
import { useAddCustomJsonComponentNavigations } from './hooks/useAddCustomJsonComponentNavigations';

export interface JsonComponentSwitchProps
  extends CustomComponentsProps,
    Readonly<{
      componentData: JsonDataBlobComponentFragment;
      isEditMode?: boolean;
    }> {}

/**
 * Displays the appropriate CustomJsonComponent for the schema of this component instance
 */
export const JsonComponentSwitch = (props: JsonComponentSwitchProps) => {
  const { componentData } = props;
  const data = componentData.containerContent;
  useAddCustomJsonComponentNavigations(props);
  const jsonComponentTypes = useGetJSONComponents(props, data);

  if (!jsonComponentTypes.length) {
    return null;
  }

  return (
    <>
      {jsonComponentTypes.map(component => {
        return component;
      })}
    </>
  );
};
